export default __webpack_public_path__ + "3b4800a7887f35803926756432dadd4c.png";